import { baseApi } from "./baseApi";

const partnerApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getPartners: builder.query({
      query: (params) => {
        let url = "partners";

        url += "?";

        if (params.all_pages) {
          url += `all_pages=${params.all_pages}&`;
        }

        if (params.page) {
          url += `page=${params.page}&`;
        }
        if (params.page_size) {
          url += `page_size=${params.page_size}&`;
        }
        if (params.include_all) {
          url += `include_all=${params.include_all}&`;
        }
        if (params.name) {
          url += `name=${params.name}&`;
        }
        if (params.code) {
          url += `code=${params.code}&`;
        }
        if (params.location_id) {
          url += `location_id=${params.location_id}&`;
        }

        // Remove the trailing '&' if any
        if (url.endsWith("&")) {
          url = url.slice(0, -1);
        }

        // Remove the trailing '?' if any
        if (url.endsWith("?")) {
          url = url.slice(0, -1);
        }
        return url;
      }
    }),
    createPartner: builder.mutation({
      query: (partner) => ({
        url: "partners",
        method: "POST",
        body: partner
      })
    }),
    updatePartner: builder.mutation({
      query: (params) => ({
        url: `partners/${params.id}`,
        method: "PUT",
        body: params.partner
      })
    }),
    getPartner: builder.query({
      query: (id) => `partners/${id}`
    }),
    addLocationToPartner: builder.mutation({
      query: (params) => ({
        url: `partners/${params.id}/locations`,
        method: "POST",
        body: params.location
      })
    }),
    addLocationsToPartner: builder.mutation({
      query: (params) => ({
        url: `partners/${params.id}/create_locations`,
        method: "POST",
        body: params.location
      })
    }),
    removeLocationFromPartner: builder.mutation({
      query: (params) => ({
        url: `partners/${params.partnerId}/locations/${params.locationId}`,
        method: "DELETE"
      })
    })
  })
});

export const {
  useGetPartnersQuery,
  useCreatePartnerMutation,
  useUpdatePartnerMutation,
  useGetPartnerQuery,
  useAddLocationToPartnerMutation,
  useAddLocationsToPartnerMutation,
  useRemoveLocationFromPartnerMutation
} = partnerApi;
